import React from "react";
import { NotesList } from "./NotesList";
import {
  useGetProviderNotesQuery,
  useCreateProviderNoteMutation,
  useUpdateProviderNoteMutation,
} from "../../redux/reduxQuery/providerNotesApi";
import { skipToken } from "@reduxjs/toolkit/dist/query";

const NOTE_TYPE_LABELS: Record<string, string> = {
  sender: "Sender's Notes",
  followUp: "Follow Up Notes",
  vetting: "Vetting Notes",
  connection: "Connection Notes",
};

interface ProviderNotesListProps {
  providerId: string;
  noteType: "sender" | "followUp" | "vetting" | "connection";
  title?: string;
}

export const ProviderNotesList = ({
  providerId,
  noteType,
  title,
}: ProviderNotesListProps) => {
  const { data: notes = [], isLoading } = useGetProviderNotesQuery(
    providerId ? { providerId, noteType } : skipToken
  );
  const [createNote, { isLoading: isCreating }] =
    useCreateProviderNoteMutation();
  const [updateNote] = useUpdateProviderNoteMutation();

  const displayTitle = title || NOTE_TYPE_LABELS[noteType] || noteType;

  const handleCreate = async (body: string) => {
    await createNote({ providerId, noteType, body }).unwrap();
  };

  const handleUpdate = async (
    noteId: string,
    fields: { body?: string; isHighlighted?: boolean; isBanned?: boolean }
  ) => {
    await updateNote({ providerId, noteId, ...fields }).unwrap();
  };

  return (
    <NotesList
      notes={notes}
      isLoading={isLoading}
      isCreating={isCreating}
      title={displayTitle}
      defaultExpanded={noteType === "connection"}
      onCreateNote={handleCreate}
      onUpdateNote={handleUpdate}
    />
  );
};
